import api from './index';

export default {
  // Obtener todas las incidencias
  async searchExpendeduria(paramsOrSearch: Record<string, any> | string = '', page = 1) {
    try {
      // Si le pasamos un objeto (filtros de la store), lo usamos directamente.
      // Si le pasamos un string (modo antiguo), construimos el objeto con search y page.
      const queryParams = typeof paramsOrSearch === 'object' && paramsOrSearch !== null
        ? paramsOrSearch
        : { search: paramsOrSearch, page };

      const response = await api.get('/expendedurias/', {
        params: queryParams
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener la expendeduría', error);
      throw error;
    }
  },

  async searchMaquina(search="", expendeduria:number | null, page = 1) {
    try {
        const response = await api.get('/maquinas', {
            params: {
                search,
                expendeduria,
                page
            }
        })
        return response.data;
    } catch (error) {
        console.error('Error al obtener la maquina', error);
        throw error;
    }
  },

  async updateExpendeduria(id: number, payload: Partial<any>) {
    const response = await api.put(`/expendedurias/${id}/`, payload);
    return response.data;
  }
};